import { render, staticRenderFns } from "./NRB.vue?vue&type=template&id=5263e427&"
import script from "./NRB.vue?vue&type=script&lang=js&"
export * from "./NRB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports